import { createRouter, createWebHashHistory } from 'vue-router';
import { Ht } from './utils/dynamicImportHelper';
import runtimeConfig from '../../runtime.config.js';
import { getAccessToken } from '../utils/auth';
import { hasPermission } from '../utils/permission';

// 设置公共资源路径
if (typeof window !== 'undefined') {
    // 正确设置 __webpack_public_path__
    if (typeof __webpack_public_path__ === 'undefined') {
        var __webpack_public_path__ = './';
    }
    window.__webpack_public_path__ = __webpack_public_path__;
}

// 定义路由
const routes = [
            {
                path: '/',
                name: 'indexView',
                redirect: '/home',
                component: () => import('../pages/indexView.vue'),
                children: [
                    // 测试门户
                    {
                path: '/TestPortal',
                name: 'TestPortal',
                component: () => import('../pages/TestPortal.vue')
            },
            // 首页
            {
                path: 'home',
                name: 'home',
                component: () => import('../pages/home/index.vue')
            },
            {
                path: 'versionManagement',
                name: 'versionManagement',
                redirect: '/originalKnowledgeBase/managementEngineering'
            },
            {
                path: 'managementEngineering',
                name: 'managementEngineering',
                component: () => Ht(() => import('../pages/originalKnowledgeBase/managementEngineering.vue'), ['managementEngineering'])
            },
            
            {
                path: 'technicalEngineering',
                name: 'technicalEngineering',
                component: () => Ht(() => import('../pages/originalKnowledgeBase/technicalEngineering.vue'), ['technicalEngineering'])
            },
            {
                path: 'exclusiveData',
                name: 'exclusiveData',
                component: () => Ht(() => import('../pages/originalKnowledgeBase/exclusiveData.vue'), ['exclusiveData'])
            },
            {
                path: 'aimeFrameTech',
                name: 'aimeFrameTech',
                component: () => Ht(() => import('../pages/aimeFrame/indexTech.vue'), ['aimeFrameTech'])
            },
            {
                path: 'aimeEnterpriseLib',
                name: 'aimeEnterpriseLib',
                component: () => Ht(() => import('../pages/aimeFrame/indexEnterpriseLib.vue'), ['aimeEnterpriseLib'])
            },
            {
                path: 'aimeFrameMange',
                name: 'aimeFrameMange',
                component: () => Ht(() => import('../pages/aimeFrame/indexMange.vue'), ['aimeFrameMange'])
            },
            {
                path: 'aimeFrameIndex',
                name: 'aimeFrameIndex',
                component: () => Ht(() => import('../pages/aimeFrame/indexFrame.vue'), ['aimeFrameIndex'])
            },
            {
                path: 'aimeTemplate',
                name: 'aimeTemplate',
                component: () => Ht(() => import('../pages/aimeTemplate/index.vue'), ['aimeTemplate'])
            },
            {
                path: 'aimeTemplateView',
                name: 'aimeTemplateView',
                component: () => Ht(() => import('../pages/aimeTemplate/view.vue'), ['aimeTemplateView'])
            },
            {
                path: 'proto',
                name: 'proto',
                component: () => Ht(() => import('../pages/doPrototype/DOPrototypeIndex.vue'), ['proto'])
            },
            {
                path: 'doGarph',
                name: 'doGarph',
                component: () => Ht(() => import('../pages/doGarph/index.vue'), ['doGarph'])
            },
            {
                path: 'dataPermission/groupList',
                name: 'dataPermissionGroupList',
                component: () =>
                    Ht(() => import('../pages/dataPermission/groupList.vue'), ['dataPermissionGroupList'])
            },
            {
                path: 'dataPermission/permissionConfig',
                name: 'dataPermissionPermissionConfig',
                component: () =>
                    Ht(() => import('../pages/dataPermission/permissionConfig.vue'), ['dataPermissionPermissionConfig'])
            },
            {
                path: 'doSetupStaff', // DO设置管理员
                name: ' doSetupStaff',
                component: () =>
                    Ht(() => import('../pages/doSetupStaff/index.vue'), [' doSetupStaff'])
            },
            {
                path: 'administrator', // 节点管理员
                name: ' administrator',
                component: () =>
                    Ht(() => import('../pages/doSetupStaff/administrator.vue'), [' administrator'])
            },
            {
                path: 'orgUser/userList', //用户管理
                name: 'orgUserUserList',
                component: () => Ht(() => import('../pages/orgUser/userList.vue'), ['orgUserUserList'])
            },
            {
                path: 'orgUser/userInfo',
                name: 'orgUserUserInfo',
                component: () => Ht(() => import('../pages/orgUser/userDetail.vue'), ['orgUserUserInfo'])
            },
            {
                path: 'orgUser/editUserInfo',
                name: 'orgUserEditUserInfo',
                component: () => Ht(() => import('../pages/orgUser/editUserInfo.vue'), ['orgUserEditUserInfo'])
            },
            {
                path: 'orgUser/additionalPermissionConfig',//用户额外权限配置
                name: 'orgUserAdditionalPermissionConfig',
                component: () =>
                    Ht(
                        () => import('../pages/orgUser/additionalPermissionConfig.vue'),
                        ['orgUserAdditionalPermissionConfig']
                    )
            },
            {
                path: 'orgUser/userPermissionOverview',
                name: 'orgUserUserPermissionOverview',
                component: () =>
                    Ht(
                        () => import('../pages/orgUser/additionalPermissionConfig.vue'),
                        ['orgUserUserPermissionOverview']
                    )
            },
            {
                path: 'orgUser/userGroupAssign',
                name: 'orgUserUserGroupAssign',
                component: () => Ht(() => import('../pages/orgUser/userGroupAssign.vue'), ['orgUserUserGroupAssign'])
            },
            {
                path: 'processManagement/processDesign',
                name: 'processManagementProcessDesign',
                component: () => Ht(() => import('../pages/processManagement/processDesign.vue'), ['processManagementProcessDesign'])
            },
            {
                path: 'processManagement/processDesigner',
                name: 'processManagementProcessDesigner',
                component: () => Ht(() => import('../pages/processManagement/processDesigner.vue'), ['processManagementProcessDesigner'])
            },
            {
                path: 'processManagement/businessBinding',
                name: 'processManagementbusinessBinding',
                component: () => Ht(() => import('../pages/processManagement/businessBinding.vue'), ['processManagementbusinessBinding'])
            },
            {
                path: 'collaborativeWork/completedMatters',//已发事项
                name: 'collaborativeWorkcompletedMatters',
                component: () => Ht(() => import('../pages/collaborativeWork/completedMatters.vue'), ['collaborativeWorkcompletedMatters'])
            },
            {
                path: 'collaborativeWork/toDoList',//待办事项
                name: 'collaborativeWorktoDoList',
                component: () => Ht(() => import('../pages/collaborativeWork/toDoList.vue'), ['collaborativeWorktoDoList'])
            },
            {
                path: 'collaborativeWork/completedTasks',//已发事项
                name: 'collaborativeWorkcompletedTasks',
                component: () => Ht(() => import('../pages/collaborativeWork/completedTasks.vue'), ['collaborativeWorkcompletedTasks'])
            },
            {
                path: 'collaborativeWork/dome',//待办事项
                name: 'collaborativeWorkdome',
                component: () => Ht(() => import('../pages/collaborativeWork/dome.vue'), ['collaborativeWorkdome'])
            },
            {
                path: 'sysLogByUser/logList',//日志记录
                name: 'logList',
                component: () => Ht(() => import('../pages/sysLogByUser/logList.vue'), ['logList'])
            },
            {
                path: 'sysResource/resource',//资源管理
                name: 'resource',
                component: () => Ht(() => import('../pages/sysResource/sysResource.vue'), ['resource'])
            },
            {
                path: 'orgGroup',//组织管理
                name: 'orgGroup',
                component: () => Ht(() => import('../pages/orgGroup/index.vue'), ['orgGroup'])
            },
            {
                path: 'orgRole',//角色管理
                name: 'orgRole',
                component: () => Ht(() => import('../pages/orgRole/index.vue'), ['orgRole'])
            },
            {
                path: 'documentManagement',//文档管理
                name: 'documentManagement',
                component: () => Ht(() => import('../pages/documentManagement/index.vue'), ['documentManagement'])
            },
            {
                path: 'documentManagement/annotate/:id',//文档标注工作台（也可通过文档管理页全屏弹窗打开）
                meta: { title: '文档标注' },
                name: 'docAnnotate',
                component: () => Ht(() => import('../pages/documentManagement/annotate.vue'), ['docAnnotate'])
            },
            // 抽离配置页面路由
            {
                path: 'originalKnowledgeBase/managementEngineering',
                name: 'originalKnowledgeBaseManagementEngineering',
                component: () => Ht(() => import('../pages/originalKnowledgeBase/managementEngineering.vue'), ['originalKnowledgeBaseManagementEngineering'])
            },
            {
                path: 'originalKnowledgeBase/technicalEngineering',
                name: 'originalKnowledgeBasetechnicalEngineering',
                component: () => Ht(() => import('../pages/originalKnowledgeBase/technicalEngineering.vue'), ['originalKnowledgeBasetechnicalEngineering'])
            },
            {
                path: 'originalKnowledgeBase/exclusiveData',
                name: 'originalKnowledgeBaseexclusiveData',
                component: () => Ht(() => import('../pages/originalKnowledgeBase/exclusiveData.vue'), ['originalKnowledgeBaseexclusiveData'])
            },
            {
                path: 'dataPermissionGroupNew/userList',
                name: 'dataPermissionGroupNewUserList',
                component: () => Ht(() => import('../pages/dataPermissionGroupNew/userList.vue'), ['dataPermissionGroupNewUserList'])
            },
            {
                path: 'dataPermissionGroupNew/additionalPermissionConfig',
                name: 'dataPermissionGroupNewAdditionalPermissionConfig',
                component: () => Ht(() => import('../pages/dataPermissionGroupNew/components/additionalPermissionConfig.vue'), ['dataPermissionGroupNewAdditionalPermissionConfig'])
            },
            {
                path: 'dataPermissionGroupNew/groupList',
                name: 'dataPermissionGroupNewGroupList',
                component: () => Ht(() => import('../pages/dataPermissionGroupNew/groupList.vue'), ['dataPermissionGroupNewGroupList'])
            },
            {
                path: 'dataPermissionGroupNew/permissionConfig',
                name: 'dataPermissionGroupNewPermissionConfig',
                component: () => Ht(() => import('../pages/dataPermissionGroupNew/components/permissionConfig.vue'), ['dataPermissionGroupNewPermissionConfig'])
            },
            {
                path: 'originalKnowledgeBase/filePreview',
                name: 'originalKnowledgeBaseFilePreview',
                component: () => Ht(() => import('../pages/originalKnowledgeBase/filePreview.vue'), ['originalKnowledgeBaseFilePreview'])
            },
            // Word 文档解析打标签工具
            {
                path: 'wordTagging',
                name: 'wordTagging',
                component: () => Ht(() => import('../pages/wordTagging/index.vue'), ['wordTagging'])
            },
            // 当前数商的数据集成配置
            {
                path: 'integration/datasource',
                name: 'integrationDatasource',
                component: () => Ht(() => import('../pages/integration/datasource/index.vue'), ['integrationDatasource'])
            },
            // 当前数商的数据集成 - SQL 数据集（Goal 12A/12B）
            {
                path: 'integration/dataset',
                name: 'integrationDataset',
                component: () => Ht(() => import('../pages/integration/dataset/index.vue'), ['integrationDataset'])
            },
            // 当前数商的数据集成 - 数据集到DO映射（Goal 14A/14B）
            {
                path: 'integration/mapping',
                name: 'integrationMapping',
                component: () => Ht(() => import('../pages/integration/mapping/index.vue'), ['integrationMapping'])
            },
            // 当前数商的数据集成 - 任务配置（模拟版）
            {
                path: 'integration/task',
                name: 'integrationTask',
                component: () => Ht(() => import('../pages/integration/task/index.vue'), ['integrationTask'])
            },
            // 当前数商的数据集成 - 执行监控（模拟版：抽取数据生成DO）
            {
                path: 'integration/execution',
                name: 'integrationExecution',
                component: () => Ht(() => import('../pages/integration/execution/index.vue'), ['integrationExecution'])
            },
            // 计划任务 - 任务视图
            {
                path: 'plannedTask/taskView',
                name: 'plannedTaskTaskView',
                component: () => Ht(() => import('../pages/plannedTask/taskView/index.vue'), ['plannedTaskTaskView'])
            },
            // 计划任务 - 人员视图
            {
                path: 'plannedTask/personnelView',
                name: 'plannedTaskPersonnelView',
                component: () => Ht(() => import('../pages/plannedTask/personnelView/index.vue'), ['plannedTaskPersonnelView'])
            },
            // 计划任务 - OA人员绑定
            {
                path: 'plannedTask/oaUserBinding',
                name: 'plannedTaskOaUserBinding',
                component: () => Ht(() => import('../pages/plannedTask/oaUserBinding/index.vue'), ['plannedTaskOaUserBinding'])
            },
            // 计划任务 - 任务查看授权
            {
                path: 'plannedTask/taskViewPermission',
                name: 'plannedTaskTaskViewPermission',
                component: () => Ht(() => import('../pages/plannedTask/taskViewPermission/index.vue'), ['plannedTaskTaskViewPermission'])
            },
        ]
    },
    
    // 登录页面
    {
        path: '/login',
        name: 'login',
        component: () => import('../pages/login/index.vue')
    },
    {
        path: '/register',
        name: 'register',
        component: () => import('../pages/register/index.vue')
    },
    // SSO回调页面
    {
        path: '/sso-auth',
        name: 'sso-auth',
        component: () => import('../pages/sso-auth/index.vue')
    },
];

/**
 * 给每个懒加载页面组件注入 name（= 路由完整 path），供 indexView 的 keep-alive :include 精确控制缓存：
 * - 页签关闭 → 从 include 名单移除 → keep-alive 立即销毁该组件缓存实例（释放内存）
 * - 重新打开 → 无缓存可命中 → 全新挂载并重新调接口
 * 背景：全项目页面均为 <script setup> 且无显式 name（Vue 自动用文件名作 __name，
 * 大量 index.vue 会重名冲突），故在路由层统一以「路由完整路径」注入，保证唯一。
 */
const namedComponents = new WeakSet();
const attachComponentNames = (routeList, parentPath = '') => {
    for (const route of routeList) {
        const fullPath = route.path.startsWith('/')
            ? route.path
            : `${parentPath === '/' ? '' : parentPath}/${route.path}`;
        if (route.component && !namedComponents.has(route.component)) {
            namedComponents.add(route.component);
            const load = route.component;
            route.component = () =>
                load().then((mod) => {
                    const comp = mod && mod.default ? mod.default : mod;
                    // 首个加载该组件的路由获得命名；同组件被多路由复用时其余路由不缓存（可接受）
                    if (comp && !comp.name) comp.name = fullPath;
                    return mod;
                });
        }
        if (route.children && route.children.length) {
            attachComponentNames(route.children, fullPath || '/');
        }
    }
};
attachComponentNames(routes);

// 抽离配置页面路由 - 已移入根路由的children中
const configRoutes = [];

// 创建路由实例
const router = createRouter({
    history: createWebHashHistory(),
    routes: [...routes, ...configRoutes]
});

// 不需要登录的路由白名单
const whiteList = ['/login', '/register', '/sso-auth'];

/**
 * 菜单权限校验
 *
 * 用户菜单缓存（localStorage.PT_USERMENULIST）来自后端 /v2/user-context/current 的 menus，
 * 每个节点带 router（如 /documentManagement）。守卫据此判断当前路由是否被授权：
 * - 超级管理员 / 管理员：全部放行（与 hasPermission 保持一致）
 * - 普通用户：路由（或其子路径）必须命中用户菜单中的任一 router，否则拦截
 */
// 无需菜单权限的公共页面（基础/落地页，避免误拦）
const ACCESS_ALLOWLIST = ['/home', '/TestPortal'];

// 判断当前用户是否为超级管理员 / 管理员（角色位与后端 RoleTypeEnum 一致）
function isAdminUser() {
  try {
    const userinfo = JSON.parse(localStorage.getItem('userinfo') || '{}') || {};
    if (userinfo.superAdmin === true || userinfo.admin === true) {
      return true;
    }
    const roleType = Number(userinfo.roleType || 0);
    return (roleType & 1) > 0 || (roleType & 2) > 0;
  } catch (e) {
    return false;
  }
}

// 展平菜单树，收集所有 router
function collectMenuRouters(menus, set = new Set()) {
  for (const m of menus || []) {
    if (m && m.router) {
      set.add(String(m.router));
    }
    if (m && m.children && m.children.length) {
      collectMenuRouters(m.children, set);
    }
  }
  return set;
}

// 生成目标路径的各级前缀（含自身）：/a/b/c → ['/a', '/a/b', '/a/b/c']
function buildPathPrefixes(path) {
  const segments = path.split('/').filter(Boolean);
  const prefixes = [];
  let current = '';
  for (const seg of segments) {
    current = current ? `${current}/${seg}` : `/${seg}`;
    prefixes.push(current);
  }
  return prefixes;
}

// 判断目标路径是否命中用户菜单（跟随父级菜单入口）
// 匹配规则（与 indexView 菜单导航 findMenuKeyByRoute 的双向包含思路一致）：
//   1. 目标路径与菜单 router 相等 / 互相包含
//      → 子路径跟随父级菜单（/documentManagement 下所有页面）
//      → 兼容同页面的多路由写法（/originalKnowledgeBase/xxx 与 /xxx）
//   2. 目标路径的各级前缀命中任一菜单 router（或互相包含）
//      → 同一父目录下的兄弟页面 / 弹窗内部页也能访问
//        （有 /dataPermissionGroupNew/userList 即可访问 /dataPermissionGroupNew/additionalPermissionConfig）
function hasMenuAccess(path) {
  let menus;
  try {
    menus = JSON.parse(localStorage.getItem('PT_USERMENULIST') || 'null');
  } catch (e) {
    menus = null;
  }
  // 菜单尚未加载或加载失败时放行，避免误拦截（页面挂载后会重新拉取菜单）
  if (!Array.isArray(menus) || menus.length === 0) {
    return true;
  }
  const routers = collectMenuRouters(menus);
  if (routers.size === 0) {
    return true;
  }
  const target = path.split('?')[0].replace(/\/+$/, '');
  const prefixes = buildPathPrefixes(target);
  for (const r of routers) {
    const rp = String(r).split('?')[0].replace(/\/+$/, '');
    if (!rp) continue;
    // 1. 目标路径本身命中
    if (target === rp || target.includes(rp) || rp.includes(target)) {
      return true;
    }
    // 2. 目标路径的各级前缀命中（兄弟页面 / 弹窗内部页跟随父目录）
    for (const p of prefixes) {
      if (p === rp || p.includes(rp) || rp.includes(p)) {
        return true;
      }
    }
  }
  return false;
}

/* 暂时注释掉路由守卫，后续需要时取消注释即可
// 全局前置守卫
router.beforeEach((to, from, next) => {
    // 统一通过前端运行配置决定是否为嵌入模式
    const isEmbedMode = runtimeConfig.embedMode === true;
    
    // 判断是否通过 URL 参数隐藏布局（外部系统引入时使用）
    const hideLayoutFromQuery = to.query.hideLayout === 'true';
    
    // 设置是否显示布局（嵌入模式或通过参数指定时不显示布局）
    to.meta.showLayout = !isEmbedMode && !hideLayoutFromQuery;
    
    // 获取 token
    const token = getAccessToken();
    
    // 调试日志
    console.log('路由守卫:', {
        to: to.path,
        from: from.path,
        token: token ? '存在' : '不存在',
        tokenValue: token ? token.substring(0, 20) + '...' : '',
        localStorageToken: token ? '存在' : '不存在'
    });
    
    if (isEmbedMode) {
        console.log('嵌入模式，跳过独立登录校验');
        next();
        return;
    }

    // 如果是白名单中的路由，直接放行（支持带参数的路径）
    const pathWithoutQuery = to.path.split('?')[0];
    if (whiteList.includes(to.path) || whiteList.includes(pathWithoutQuery)) {
        console.log('白名单路由，直接放行');
        next();
        return;
    }
    
    // 如果没有 token，跳转到登录页面
    if (!token) {
        console.log('无token，跳转到登录页');
        next({
            path: '/login',
            query: {
                target: encodeURIComponent(to.fullPath || '/home')
            }
        });
        return;
    }
    
    // 有 token，继续访问
    // 菜单权限校验：超管/管理员、公共页面直接放行；
    // 普通用户必须命中其菜单 router（或其子路径），否则拦截并跳转首页
    if (isAdminUser() || ACCESS_ALLOWLIST.includes(pathWithoutQuery) || hasMenuAccess(pathWithoutQuery)) {
        console.log('有token，放行');
        next();
        return;
    }
    // 未命中菜单的页面：若路由声明了 meta.permission（按钮权限编码），
    // 则按按钮权限放行——用于「有权限页面内按钮弹窗打开的非菜单页面」，
    // 权限编码与 v-permission 共用一套，配置资源 alias 后自动生效
    const metaPermission = to.meta && to.meta.permission;
    if (metaPermission && hasPermission(metaPermission)) {
        console.log('按钮权限放行:', metaPermission);
        next();
        return;
    }
    console.log('无菜单权限，跳转首页:', pathWithoutQuery);
    next({ path: '/home', replace: true });
});
*/

export default router;
